import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux";
import { invokeGetService } from "../../../store/global/actions";
import { Box, Button, Grid, Tooltip, Typography } from "@material-ui/core";
import CustomizedTables from "../../atoms/table";
import { StyledTableCell, StyledTableRow } from "../../atoms/table/tableStyles";
import { convertToLocalTime } from "../../../utils/commonUtils";
import { getLoggedInUserId } from "../../../store/auth/selectors";
import { getBlueprintDetails, getReRender } from "../../../store/global/selectors";
import { Alert } from '@material-ui/lab';
import ReadMoreDialog from "../../atoms/table/ReadMoreDialog";

const tableHeader = [
    { label: 'Version', name: 'version' },
    { label: 'Type', name: 'type' },
    { label: 'Description', name: 'desc' },
    { label: 'Release Date', name: 'updatedDate' }
]



export const PlatformSchemaVersions = ({ isMigrating, isBlueprintOwner, migratePlatformSchema, checkPlatformSchemaMigration }) => {
    const dispatch = useDispatch();
    const loggedInUserId = useSelector(getLoggedInUserId);
    const { user_id: blueprintOwner } = useSelector(getBlueprintDetails) || {};
    const reRender = useSelector(getReRender);

    const [availableVersions, setAvailableVersions] = useState([]);
    const [isFetching, setIsFetching] = useState(false);
    const [currentVersion, setCurrentVersion] = useState(null);

    const getPlatformSchema = async () => {
        setIsFetching(true);
        const response = await dispatch(invokeGetService('platformSchemaAvailableVersions', {}));
        if (response?.status) {
            setAvailableVersions(response?.data);
            const currentVer = response?.data?.find(item => item.selectedSchema)?.version;
            setCurrentVersion(currentVer);
        }
        setIsFetching(false);
    }


    useEffect(() => {
        if (!isMigrating) {
            getPlatformSchema();
        }
    }, [reRender, isMigrating])



    const canMigrate = (row) => loggedInUserId === blueprintOwner && row.selectedSchema !== true && !isMigrating;




    return (
        <Grid container alignItems="center" spacing={2}>
            <Grid item xs={12}>

                {!isFetching && !isBlueprintOwner &&
                    <Alert severity="error" style={{ marginBottom: 10 }}>{`Only the blueprint owner can migrate the Platform Schema. Please contact the owner to proceed`}</Alert>
                }

                {currentVersion &&
                    <Grid item xs={12} style={{padding: "5px 0px"}}>
                        <Typography
                            id="current_version"
                            variant="body1"
                            style={{ fontSize: '0.900rem', fontWeight: 600 }}
                        >
                            {`Current Version - ${currentVersion}`}
                        </Typography>
                    </Grid>
                }


                <CustomizedTables id="platform_schema_version_table" dataUiTourId="platformschema-versions-table" size="small" headers={tableHeader}>
                    {isFetching ? <StyledTableRow>
                        <StyledTableCell align={'center'} colSpan={4} component="td" style={{ padding: 15 }}>
                            Loading..
                        </StyledTableCell>
                    </StyledTableRow>

                        :
                        availableVersions?.length < 1 ? (
                            <StyledTableRow>
                                <StyledTableCell align={'center'} colSpan={4} component="td" style={{ padding: 15 }}>
                                    No Platform Schema Available.
                                </StyledTableCell>
                            </StyledTableRow>
                        ) : (
                            availableVersions?.map((item, index) => (
                                <StyledTableRow key={index} selected={item.selectedSchema} style={item.selectedSchema ? { backgroundColor: "#feebf2 !important" } : {}}>
                                    <StyledTableCell align="left">
                                        <Box
                                            display="flex"
                                            alignItems="center"
                                            justifyContent="space-between"
                                        >
                                            <span
                                                style={{
                                                    fontWeight: item.selectedSchema ? 600 : 400,
                                                }}
                                            >
                                                {item.version}
                                                {item.selectedSchema && ' (Current)'}
                                            </span>


                                            {canMigrate(item) && (
                                                <Box className="row-actions" display="flex" gap={8}>
                                                    <Button
                                                        id="impact_btn"
                                                        size="small"
                                                        disabled={!isBlueprintOwner}
                                                        variant="text"
                                                        disableRipple
                                                        onClick={() => checkPlatformSchemaMigration(item.version)}
                                                        style={{ textTransform: "none" }}
                                                    >
                                                        See Impact
                                                    </Button>

                                                    <Button
                                                        id="migrate_btn"
                                                        size="small"
                                                        disabled={!isBlueprintOwner}
                                                        variant="text"
                                                        disableRipple
                                                        color="primary"
                                                        onClick={() => migratePlatformSchema(item.version)}
                                                        style={{ textTransform: "none" }}
                                                    >
                                                        Migrate
                                                    </Button>
                                                </Box>
                                            )}

                                        </Box>
                                    </StyledTableCell>

                                    <StyledTableCell align={'left'}>
                                        <Tooltip title={item.user_id ? "Custom schema created by blueprint owner" : "Provided and maintained by HyperBlox"}>
                                            <span>
                                                {item.user_id ? "Local" : "System"}
                                            </span>
                                        </Tooltip>
                                    </StyledTableCell>
                                    <StyledTableCell align={'left'}>
                                        {(item.desc && item.desc !== "") &&
                                            <ReadMoreDialog
                                                triggerLabel={"View"}
                                                title={item.version}
                                                content={item.desc}
                                            />
                                        }
                                    </StyledTableCell>
                                    <StyledTableCell align={'left'}>{convertToLocalTime(item.updatedAt)}</StyledTableCell>
                                </StyledTableRow>
                            ))
                        )}
                </CustomizedTables>
            </Grid>
        </Grid>
    )
}